
import React, { useState } from "react";
import { FirebaseError } from "firebase/app";
import "../screenstyles/Login.css";
import { useNavigate } from "react-router-dom";
import splashImage from "../assets/images/splashImage4.png";
import { useAuth } from "../contexts/AuthContext"

function getLoginErrorMessage(error: unknown): string {
  if (!(error instanceof FirebaseError)) {
    return "حدث خطأ أثناء تسجيل الدخول. تحقق من اتصالك ثم حاول مجددًا.";
  }

  switch (error.code) {
    case "auth/invalid-credential":
    case "auth/user-not-found":
    case "auth/wrong-password":
      return "البريد الإلكتروني أو كلمة المرور غير صحيحة.";
    case "auth/invalid-email":
      return "صيغة البريد الإلكتروني غير صحيحة.";
    case "auth/user-disabled":
      return "تم تعطيل هذا الحساب.";
    case "auth/too-many-requests":
      return "تم إجراء محاولات كثيرة. حاول مرة أخرى لاحقًا.";
    case "auth/network-request-failed":
      return "تعذر الاتصال بالخدمة. تحقق من الإنترنت وحاول مجددًا.";
    default:
      return "تعذر تسجيل الدخول إلى لوحة التحكم.";
  }
}

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);

    try {
      await login(email, password);
      navigate("/", { replace: true });
    } catch (loginError) {
      console.error("Firebase login failed:", loginError);
      setError(getLoginErrorMessage(loginError));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page" dir="rtl">
      <div className="login-bg-orb login-bg-orb-one"></div>
      <div className="login-bg-orb login-bg-orb-two"></div>

      <div className="login-card">
        <div className="login-image-section">
          <div className="login-brand-badge">SHOOF Dashboard</div>
          <img src={splashImage} alt="Login" className="login-image" />
          <div className="login-image-content">
            <h2>مرحبًا بعودتك</h2>
            <p>قم بتسجيل الدخول لإدارة المنتجات، الحسابات، السيريلات والطلبات من لوحة واحدة.</p>
          </div>
        </div>

        <div className="login-form-section">
          <div className="login-form-header">
            <span className="login-eyebrow">لوحة التحكم</span>
            <h1 className="login-title">تسجيل الدخول</h1>
            <p className="login-subtitle">أدخل بيانات حساب Firebase للوصول إلى نظام الإدارة.</p>
          </div>

          {error && <p className="error-message">{error}</p>}

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <label className="input-label" htmlFor="dashboard-email">البريد الإلكتروني</label>
              <input
                id="dashboard-email"
                type="email"
                value={email}
                placeholder="example@email.com"
                onChange={(event) => setEmail(event.target.value)}
                required
                autoComplete="email"
                className="input-field"
              />
            </div>

            <div className="input-group">
              <label className="input-label" htmlFor="dashboard-password">كلمة المرور</label>
              <input
                id="dashboard-password"
                type="password"
                value={password}
                placeholder="••••••••"
                onChange={(event) => setPassword(event.target.value)}
                required
                autoComplete="current-password"
                className="input-field"
              />
            </div>

            <button type="submit" className="submit-button" disabled={submitting}>
              {submitting ? "جارٍ تسجيل الدخول..." : "تسجيل الدخول"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
